import React, { useEffect, useState, Fragment, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header';
import DefaultSidebar from './Sidebar';
import axios from 'axios';
import { Card, Typography } from "@material-tailwind/react";
import PriceEditor from './PriceEditor';
import ModalMoveArticles from './ModalMoveArticles';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';

// On sort TABLE_HEAD du composant pour pouvoir s'en servir comme référence par défaut
const TABLE_HEAD = [
    { key: "Id", text: "Id" },
    { key: "display_id", text: "Display Id" },
    { key: "name", text: "Nom" },
    { key: "price", text: "Prix" },
    { key: "dispo", text: "Disponible" },
    { key: "editable_price", text: "Prix editable" },
    { key: "editable_stock", text: "Stock Editable" },
    { key: "display_videowall", text: "Display Videowall" },
    { key: "position_x", text: "Position X" },
    { key: "position_y", text: "Position Y" },
    { key: "font_name", text: "Nom Font" },
    { key: "font_size", text: "Taille Font" },
    { key: "font_color", text: "Couleur Font" },
    { key: "position_icon_x", text: "Position Icon X" },
    { key: "position_icon_y", text: "Position Icon Y" },
    { key: "width_icon", text: "Taille Icon" },
];

function ListArticles() {
    const [listprice, setDate] = useState([]);
    const [search, setSearch] = useState('');
    const [sortedBy, setSortedBy] = useState();
    const [counter, setCounter] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    const [showModalMove, setShowModalMove] = useState(false);
    const [idPdv, setIdPdv] = useState();
    const [dati, setDates] = useState([]);
    const [clientId, setClientId] = useState();
    const [data_programme, setProgramme] = useState([]);
    const [selectedDisplayId, setSelectedDisplayId] = useState('');
    const [editingPrice, setEditingPrice] = useState(null); // { Id, value } — édition rapide du prix dans le tableau
    
    // --- NOUVEAUX STATES POUR LES COLONNES ---
    const [visibleColumns, setVisibleColumns] = useState(TABLE_HEAD.map(col => col.key));
    const [isColSelectorOpen, setIsColSelectorOpen] = useState(false);
    const colSelectorRef = useRef(null);
    const colButtonRef = useRef(null);

    const [choosenArticle, setChoosenArticle] = useState({
        Id: '', client_id: '', name: '', price: '', dispo: '', display_id: '',
        id_product_display: '', editable_price: '', editable_stock: '',
        display_videowall: '', id_pdv: '', position_x: '', position_y: '',
        font_size: '', font_name: '', font_color: '', indispo_name: '',
        position_icon_x: '', position_icon_y: '', width_icon: '', token: '',
        value: '', linked_article_id: '',
    });

    const params = useParams();
    let token = localStorage.getItem("token");

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    const data = {
        token: token,
        id_pdv: params.id_pdv
    };

    // --- CHARGEMENT DU LOCAL STORAGE ---
    useEffect(() => {
        const savedSearch = localStorage.getItem('searchArticlesValue');
        if (savedSearch) setSearch(savedSearch);

        const savedDisplayId = localStorage.getItem('selectedDisplayIdValue');
        if (savedDisplayId) setSelectedDisplayId(savedDisplayId);

        const savedColumns = localStorage.getItem('visibleColumnsArticles');
        if (savedColumns) {
            try {
                setVisibleColumns(JSON.parse(savedColumns));
            } catch (error) {
                localStorage.removeItem('visibleColumnsArticles');
            }
        }
    }, []);

    // --- SAUVEGARDE DES COLONNES ---
    useEffect(() => {
        localStorage.setItem('visibleColumnsArticles', JSON.stringify(visibleColumns));
    }, [visibleColumns]);

    // --- FERMETURE DU MENU COLONNES AU CLIC EXTERIEUR ---
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                isColSelectorOpen &&
                colButtonRef.current && !colButtonRef.current.contains(event.target) &&
                colSelectorRef.current && !colSelectorRef.current.contains(event.target)
            ) {
                setIsColSelectorOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isColSelectorOpen]);

    // Rechargement des articles (utilisé au montage ET après une sauvegarde — évite window.location.reload)
    const loadArticles = () => {
        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/admin/auth/listeArticles`, data, { headers })
            .then(res => setDate(res.data))
            .catch(err => console.log(err));
    };

    // Édition rapide du prix directement dans le tableau (double-clic sur la cellule Prix).
    const savePriceInline = (article, newPrice) => {
        const p = String(newPrice).trim();
        setEditingPrice(null);
        if (p === '' || isNaN(Number(p)) || Number(p) === Number(article.price)) return;
        const pdv = article.id_pdv || params.id_pdv;
        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/auth/user/updateArticle/PriceEat`,
            { ...article, price: p, id_pdv: pdv, token }, { headers })
            .then(res => {
                if (res.status === 200) {
                    axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/retrivePinCode`, { idPdv: pdv }, { headers }).catch(() => { });
                    toast.success('Prix mis à jour');
                    loadArticles();
                } else {
                    toast.error('Réponse inattendue');
                }
            })
            .catch(() => toast.error('Échec de la mise à jour du prix'));
    };

    useEffect(() => {
        setIdPdv(params.id_pdv);
        setClientId(params.id_client);
        loadArticles();
    }, []);

    //?  Video Array Logic (inchangée)
    let videoAll = [];
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => setDates(res.data))
            .catch(err => console.log(err));

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/gat_all_programme`)
            .then(res => setProgramme(res.data))
            .catch(err => console.log(err));
    }, []);

    let datiIdPdv = [];
    let datiIdPdvProgramme = [];
    for (let i = 0; i < dati.length; i++) {
        if (dati[i]._id_pdv === idPdv) datiIdPdv.push(dati[i]);
    }
    for (let c = 0; c < data_programme.length; c++) {
        if (data_programme[c].idPdv === idPdv) datiIdPdvProgramme.push(data_programme[c]);
    }
    // Index de TOUS les devices par pincode (lien programme -> device)
    const deviceByPin = {};
    dati.forEach(d => { if (d && d._pin_code != null && d._pin_code !== '') deviceByPin[String(d._pin_code)] = d; });

    // Applique cb(displayId, slotIndex) sur chaque id d'une chaîne "a;b-c;d"
    // (slots séparés par ';', dalles videowall par '-')
    const eachDisplayId = (str, cb) => {
        String(str || '').split(';').forEach((seg, x) => {
            const s = seg.trim();
            if (!s) return;
            (s.includes('-') ? s.split('-') : [s]).forEach(id => { const k = String(id).trim(); if (k) cb(k, x); });
        });
    };

    let orientationByDisplay = {};
    const addVideo = (id, url) => { if (id) videoAll.push({ id: String(id), url }); };
    const setOrient = (id, dev) => { if (id && dev) orientationByDisplay[String(id)] = (dev._video_code_3 === 'portrait') ? 'portrait' : 'paysage'; };

    // 1) DEVICES de ce pdv : TOUS les display_id d'un player -> sa vidéo principale (_video_url).
    //    Un player = 1 écran = 1 vidéo ; ses display_id (ex. 1;2;3;4) sont des zones de prix sur CETTE vidéo.
    //    (Ne PAS mapper par slot _video_url_2/_3 : ces slots sont une playlist, pas 1 vidéo par display.)
    datiIdPdv.forEach(d => {
        const primary = d._video_url;
        if (d._display_id) { addVideo(d._display_id, primary); setOrient(d._display_id, d); }
        eachDisplayId(d._video_code, (id) => { addVideo(id, primary); setOrient(id, d); });
    });

    // 2) PROGRAMMES de ce pdv : idem, vidéo principale = Videourl1 (fallback device lié via _pin_code).
    datiIdPdvProgramme.forEach(p => {
        const dev = deviceByPin[String(p._pin_code)];
        const primary = p.Videourl1 || (dev ? dev._video_url : undefined);
        eachDisplayId(p.displayId, (id) => { addVideo(id, primary); if (dev) setOrient(id, dev); });
    });

    // Dédoublonnage par id ; complète une url manquante par une url trouvée ailleurs
    const filteredVideoArray = videoAll.reduce((acc, current) => {
        const existing = acc.find(item => item.id === current.id);
        if (!existing) return acc.concat([{ ...current }]);
        if ((!existing.url || existing.url === '') && current.url) existing.url = current.url;
        return acc;
    }, []);

    // Groupes de dalles videowall (ex. "1-2-3-4") → déduction du quadrant (TL/TR/BL/BR)
    let wallGroups = [];
    const collectGroups = (codeStr) => {
        if (!codeStr) return;
        String(codeStr).split(';').forEach(seg => { if (seg.includes('-')) wallGroups.push(seg.split('-')); });
    };
    datiIdPdv.forEach(d => collectGroups(d._video_code));
    datiIdPdvProgramme.forEach(p => collectGroups(p.displayId));
    //?  Fin Video Array

    // --- HANDLERS ---
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        localStorage.setItem('searchArticlesValue', value);
    };

    const handleDisplayIdChange = (e) => {
        const value = e.target.value;
        setSelectedDisplayId(value);
        localStorage.setItem('selectedDisplayIdValue', value);
    };

    const handleColumnToggle = (key) => {
        setVisibleColumns(prev => {
            if (prev.includes(key)) {
                if (prev.length === 1) return prev; // Garder au moins 1 colonne
                return prev.filter(k => k !== key);
            } else {
                return [...prev, key];
            }
        });
    };

    // --- PREPARATION DES DONNEES (Tri et Filtre) ---
    const sorted = listprice.sort((a, b) => {
        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        } else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });

    // On pré-filtre les données pour le tableau et l'export
    const filteredArticles = sorted.filter((item) => {
        const searchTerm = search.toLowerCase();
        const matchesSearch = searchTerm === ''
            || item.name?.toLowerCase().includes(searchTerm)
            || item.display_id?.toString().toLowerCase().includes(searchTerm);

        const matchesSelectDisplayId = selectedDisplayId === ''
            || item.display_id?.toString() === selectedDisplayId;

        return matchesSearch && matchesSelectDisplayId;
    });

    const uniqueDisplayIds = [...new Set(sorted.map(item => item.display_id).filter(Boolean))].sort();

    // --- EXPORT EXCEL ---
    const handleExportExcel = () => {
        const dataToExport = filteredArticles.map(item => {
            const row = {};
            // On n'exporte que les colonnes actuellement visibles !
            TABLE_HEAD.filter(col => visibleColumns.includes(col.key)).forEach(col => {
                row[col.text] = item[col.key];
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Articles");
        XLSX.writeFile(workbook, `Articles_Pdv_${idPdv || 'Export'}.xlsx`);
    };

    // --- COMPOSANT : Popover des colonnes ---
    const ColumnSelectorPopover = () => (
        <div ref={colSelectorRef} className="absolute top-full left-0 mt-2 w-64 p-4 bg-white rounded-lg shadow-xl z-20 border border-slate-200 max-h-80 overflow-y-auto text-left">
            <h4 className="text-lg font-semibold mb-3 text-slate-800">Colonnes affichées</h4>
            <div className="flex flex-col gap-2">
                {TABLE_HEAD.map((col) => (
                    <div key={col.key} className="flex items-center">
                        <input
                            type="checkbox"
                            id={`col-${col.key}`}
                            checked={visibleColumns.includes(col.key)}
                            onChange={() => handleColumnToggle(col.key)}
                            className="mr-2 h-4 w-4 rounded cursor-pointer"
                        />
                        <label htmlFor={`col-${col.key}`} className="text-sm select-none cursor-pointer text-slate-700">
                            {col.text}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );

    const ListArticle = (() => {
        return (
            <div className="w-full">
                {filteredArticles.length > 0 && (
                    <div className='flex justify-around text-center py-4'>
                        <h3 className='text-slate-700 font-semibold'>Nom Client: {filteredArticles[0].client_id} </h3>
                        <h3 className='text-slate-700 font-semibold'>Id Pdv: {filteredArticles[0].id_pdv} </h3>
                    </div>
                )}
                
                <Card className="h-full w-full overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left rounded-2xl">
                        <thead>
                            <tr className='sticky top-0'>
                                {/* On filtre les en-têtes selon visibleColumns */}
                                {TABLE_HEAD.filter(head => visibleColumns.includes(head.key)).map((head) => (
                                    <th
                                        key={head.key}
                                        className="border bg-slate-700 text-white p-4 cursor-pointer whitespace-nowrap"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                    >
                                        <Typography variant="small" className="font-normal leading-none ">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="ml-1 text-xs">{counter % 2 === 0 ? ' ▲' : ' ▼'}</span>
                                            )}
                                        </Typography>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredArticles.map((data, index) => {
                                const isLast = index === filteredArticles.length - 1;
                                const classes = isLast ? "p-4" : "p-4 border-b border-blue-slate-50";

                                return (
                                    <tr 
                                        key={data.Id} 
                                        className="hover:bg-slate-50 cursor-pointer transition-colors"
                                        onClick={() => { 
                                            setShowModalModify(true); 
                                            setChoosenArticle({ ...choosenArticle, ...data, token: token, value: data.id_pdv }); 
                                        }} 
                                    >
                                        {/* On boucle intelligemment sur les colonnes visibles pour créer les cellules */}
                                        {TABLE_HEAD.filter(col => visibleColumns.includes(col.key)).map((col) => {
                                            
                                            // Cas spécial : Si c'est la colonne ID, on applique le style et l'action de copie
                                            if (col.key === 'Id') {
                                                return (
                                                    <td key={col.key} className={`${classes} cursor-copy hover:bg-slate-200 transition-colors group`}
                                                        title="Cliquez pour copier l'ID" 
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // Empêche la modale de s'ouvrir
                                                            navigator.clipboard.writeText(data.Id).then(() => {
                                                                toast.success("Id copié dans le presse-papier !", {
                                                                    position: "bottom-right",
                                                                    autoClose: 2000,
                                                                });
                                                            });
                                                        }}>
                                                        <Typography variant="small" color="blue-gray" className="font-bold text-blue-600 group-hover:text-blue-800 flex items-center gap-2">
                                                            {data[col.key]}
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                                                            </svg>
                                                        </Typography>
                                                    </td>
                                                );
                                            }

                                            // Prix : édition rapide au double-clic (sans ouvrir l'éditeur)
                                            if (col.key === 'price') {
                                                const editing = editingPrice && String(editingPrice.Id) === String(data.Id);
                                                return (
                                                    <td key={col.key} className={`${classes} group`} title="Double-cliquez pour modifier le prix"
                                                        onDoubleClick={(e) => { e.stopPropagation(); setEditingPrice({ Id: data.Id, value: String(data.price ?? '') }); }}>
                                                        {editing ? (
                                                            <input
                                                                autoFocus type="number" step="0.10"
                                                                className="w-24 rounded-lg border border-indigo-400 bg-white px-2 py-1 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
                                                                value={editingPrice.value}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => setEditingPrice({ Id: data.Id, value: e.target.value })}
                                                                onBlur={() => savePriceInline(data, editingPrice.value)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') savePriceInline(data, editingPrice.value); if (e.key === 'Escape') setEditingPrice(null); }}
                                                            />
                                                        ) : (
                                                            <Typography variant="small" color="blue-gray" className="font-normal">
                                                                {data[col.key]}
                                                                <span className="ml-1 text-[10px] text-slate-300 opacity-0 group-hover:opacity-100">✎</span>
                                                            </Typography>
                                                        )}
                                                    </td>
                                                );
                                            }

                                            // Comportement par défaut pour toutes les autres cellules
                                            return (
                                                <td key={col.key} className={classes}>
                                                    <Typography variant="small" color="blue-gray" className="font-normal">
                                                        {data[col.key]}
                                                    </Typography>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Card>
            </div>
        );
    });

    return (
        <Fragment>
            <div className="px-4">
                {/* Barre Supérieure : Colonnes, Export, Recherche et Filtre */}
                <div className='max-w-4xl flex flex-col sm:flex-row items-center text-center mx-auto my-4 gap-4'>
                    
                    {/* Bouton Colonnes */}
                    <div className="relative w-full sm:w-auto">
                        <button
                            ref={colButtonRef}
                            onClick={() => setIsColSelectorOpen(!isColSelectorOpen)}
                            className="w-full h-9 px-4 py-2 bg-slate-700 text-white rounded-lg flex items-center justify-center gap-2 whitespace-nowrap hover:bg-slate-600 transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z" />
                            </svg>
                            Colonnes
                        </button>
                        {isColSelectorOpen && <ColumnSelectorPopover />}
                    </div>

                    {/* Bouton Export Excel */}
                    <button
                        onClick={handleExportExcel}
                        className="w-full sm:w-auto h-9 px-4 bg-green-600 hover:bg-green-500 text-white rounded-lg flex items-center justify-center gap-2 font-medium transition-colors whitespace-nowrap"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        Exporter
                    </button>

                    {/* Bouton Déplacer en lot */}
                    <button
                        onClick={() => setShowModalMove(true)}
                        className="w-full sm:w-auto h-9 px-4 bg-orange-600 hover:bg-orange-500 text-white rounded-lg flex items-center justify-center gap-2 font-medium transition-colors whitespace-nowrap"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-9L21 3m0 0l-4.5 4.5M21 3v13.5" />
                        </svg>
                        Déplacer
                    </button>

                    {/* Barre de recherche */}
                    <div className="relative flex items-left w-full h-9 rounded-lg focus-within:shadow-lg bg-slate-700 overflow-hidden">
                        <div className="grid place-items-center h-full w-12 text-slate-50">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                        <input
                            className="h-full w-full outline-none text-white pr-2 bg-slate-700 placeholder-slate-50"
                            type="text"
                            id="search"
                            placeholder="Rechercher par nom ou ID..."
                            value={search}
                            onChange={handleSearchChange}
                        />
                    </div>

                    {/* Select Display ID */}
                    <div className="w-full h-9">
                        <select
                            className="h-full w-full outline-none text-white bg-slate-700 rounded-lg px-3 cursor-pointer"
                            value={selectedDisplayId}
                            onChange={handleDisplayIdChange}
                        >
                            <option value="">Tous les Display ID</option>
                            {uniqueDisplayIds.map((id, index) => (
                                <option key={index} value={id}>
                                    Display ID : {id}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <main className="flex flex-row mt-4">
                    {ListArticle()}
                    
                    {/* Bouton scroll-to-top */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer bg-white rounded-full shadow-md p-1" onClick={() => scrollToTop()}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>

                    {/* Bouton Ajouter Article */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer bg-blue-600 text-white rounded-full shadow-md p-1 hover:bg-blue-700 transition-colors" onClick={() => setShowModal(true)}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </main>
            </div>

            <PriceEditor
                isVisible={showModalModify}
                onClose={() => setShowModalModify(false)}
                mode="edit"
                article={choosenArticle}
                allArticles={listprice}
                videoFiltered={filteredVideoArray}
                wallGroups={wallGroups}
                orientationMap={orientationByDisplay}
                idPdv={idPdv}
                clientId={clientId}
                onSaved={loadArticles}
            />
            <PriceEditor
                isVisible={showModal}
                onClose={() => setShowModal(false)}
                mode="create"
                article={null}
                allArticles={listprice}
                videoFiltered={filteredVideoArray}
                wallGroups={wallGroups}
                orientationMap={orientationByDisplay}
                idPdv={idPdv}
                clientId={clientId}
                onSaved={loadArticles}
            />
            <ModalMoveArticles isVisible={showModalMove} onClose={() => setShowModalMove(false)} articles={listprice} idPdv={idPdv} />
            
            <ToastContainer />
        </Fragment>
    )
}

export default ListArticles;